module.exports = __webpack_public_path__ + "static/media/logo-main.4de1d336.svg";